export const en = {
    'goals-loading-error': 'Could not receive list of available goals/segments. Please try again in several minutes.',
    'need-some-valid-groups':
        'To get a forecast, there must be at least one fulfilled goal or segment in the retargeting list.',
    'saving-condition-general-error': 'Failed to save the retargeting list',
    'visitors-forecast-request-error': 'Forecast of number of visitors not available'
};
